<template lang="pug">
div
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width="600px" persistent)
    v-card
      v-card-title.py-4.px-5
        v-row(no-gutters align="center")
          v-col.shrink.mr-1
            v-btn.ml-n3(text icon @click="showModal = false" height)
              v-icon(color="basic800" :size="24") mdi-close
          v-col
            div.h6.basic800--text {{ $t('bundle_offer') }}
      v-divider.basic300
      v-layout.py-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      v-card-text.py-4.px-5(v-else)
        div.p1.primary--text {{ $t('bundle_offer_desc') }}
        div.mt-4
          v-img(:src="require('@/assets/images/product_bundling.png')" contain eager)

        v-card.basic200.pa-4.elevation-0.mt-4(v-if="showUpgrade")
          div.d-flex.align-center
            div.s1.primary--text {{ $t('section_growth.title') }}
            v-spacer
            div.c2.textColorHint--text.text-decoration-line-through(v-if="prices.growth_slash") {{ prices.growth_slash[$currency.code] | displayPrice($currency) }}
            div.s1.success500--text.ml-1(v-if="prices.growth") {{ prices.growth[$currency.code] | displayPrice($currency) }}
          div.c1.textColorHint--text.text-right {{ $t('monthly') }}
          v-divider.basic400.my-4
          div.c1.basic600--text(v-if="prices.growth") {{ $t('section_growth.desc', { price: $options.filters.displayPrice(prices.growth[$currency.code]) }) }}
          div.c1.basic600--text.mt-3 {{ $t('section_growth.features_desc') }}
          ul
            li.c1.basic600--text(v-if="prices.followup") {{ $t('section_growth.features_1', { price: $options.filters.displayPrice(prices.followup[$currency.code]) }) }}
            li.c1.basic600--text(v-if="prices.reseller") {{ $t('section_growth.features_agent', { price: $options.filters.displayPrice(prices.reseller[$currency.code]) }) }}
            li.c1.basic600--text {{ $t('section_growth.features_2') }}
            li.c1.basic600--text {{ $t('section_growth.features_3') }}
            li.c1.basic600--text {{ $t('section_growth.features_4') }}
          v-btn.button-AA-small.mt-5(block dark color="info500" small height="32" depressed :loading="isLoading" @click="upgradePlan") {{ $t('section_growth.button') }}

        v-card.basic200.pa-4.elevation-0.mt-4
          div.d-flex.align-center
            div.s1.primary--text {{ !showUpgrade ? $t('bundle_offer') : $t('section_add_on.title') }}
            v-spacer
            div.c2.textColorHint--text.text-decoration-line-through(v-if="prices.bundle_slash") {{ prices.bundle_slash[$currency.code] | displayPrice($currency) }}
            div.s1.success500--text.ml-1(v-if="prices.bundle") {{ prices.bundle[$currency.code] | displayPrice($currency) }}
          div.c1.textColorHint--text.text-right {{ $t('monthly') }}
          v-divider.basic400.my-4
          div.c1.basic600--text(v-if="prices.bundle") {{ $t('section_add_on.desc', { price: $options.filters.displayPrice(prices.bundle[$currency.code]) }) }}
          v-btn.button-AA-small.mt-5(block dark color="info500" small height="32" depressed :loading="isLoading" @click="openConfirmationDialog = true") {{ $t('subscribe_as_add_on') }}
      
      .modal
        y-dialog(v-if="openConfirmationDialog" v-model='openConfirmationDialog', max-width='320')
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('subscribe_bundle_offer') }}
            v-card-text.p2.primary500--text.px-4 {{ $t('subscribe_bundle_offer_confirmation') }}
            v-card-actions
              v-spacer
              v-btn(color='white', text @click="openConfirmationDialog = false")
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color='info500' depressed height=32 @click="subscribeBundle" dark :loading="isLoading")
                .button-AA-small.basic100--text {{ $t('confirm') }}

        y-dialog(v-if="openSuccessDialog" v-model='openSuccessDialog', max-width='270')
          v-card.pa-4.text-center
            div.p1.primary500--text {{ message }}
            v-btn.mt-3(color='transparent', text @click='closeDialog' block x-small)
              .button-Aa-small.primary400--text {{ $t('close') }}

</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'BundleSubscription',
  props: ['open', 'company', 'upgrade'],
  data: () => ({
    openSuccessDialog: false,
    openConfirmationDialog: false,
    isLoading: false,
    cards: [],
    message: '',
    isFetching: false,
    prices: {}
  }),
  computed: {
    ...mapState('subscriptions', ['yezzaSubscription', 'bundleSubscription']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    primaryCard () {
      if (this.cards.length === 0) {
        return null
      } else if (this.cards.length === 1) {
        return this.cards[0]
      } else {
        return this.cards.filter(c => c.primary)[0]
      }
    },
    showUpgrade () {
      if (this.upgrade) {
        return true
      }
      return false
    }
  },
  watch: {
  },
  mounted () {
    this.fetchPlanPrices()
    this.fetchCards()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPlanPrices () {
      this.isFetching = true
      this.$axios.get(`/subscription/plans`)
        .then(resp => {
          let growth = resp.data.results.find(f => f.contracts.find(i => i.code === 'YZ_GROWTH_PLAN_MM'))
          if (growth) { this.$set(this.prices, 'growth', growth.contracts.find(i => i.code === 'YZ_GROWTH_PLAN_MM').prices) }
          if (growth) { this.$set(this.prices, 'growth_slash', growth.contracts.find(i => i.code === 'YZ_GROWTH_PLAN_MM').compare_at_prices) }
          let reseller = resp.data.results.find(f => f.contracts.find(i => i.code === 'YZ_RESELLER_PLAN_MM'))
          if (reseller) { this.$set(this.prices, 'reseller', reseller.contracts.find(i => i.code === 'YZ_RESELLER_PLAN_MM').prices) }
          if (reseller) { this.$set(this.prices, 'reseller_slash', reseller.contracts.find(i => i.code === 'YZ_RESELLER_PLAN_MM').compare_at_prices) }
          let bundle = resp.data.results.find(f => f.contracts.find(i => i.code === 'YZ_PRODUCT_BUNDLE_PLAN_MM'))
          if (bundle) { this.$set(this.prices, 'bundle', bundle.contracts.find(i => i.code === 'YZ_PRODUCT_BUNDLE_PLAN_MM').prices) }
          if (bundle) { this.$set(this.prices, 'bundle_slash', bundle.contracts.find(i => i.code === 'YZ_PRODUCT_BUNDLE_PLAN_MM').compare_at_prices) }
          let followup = resp.data.results.find(f => f.contracts.find(i => i.code === 'YZ_FOLLOW_UP_PLAN_MM'))
          if (followup) { this.$set(this.prices, 'followup', followup.contracts.find(i => i.code === 'YZ_FOLLOW_UP_PLAN_MM').prices) }
          if (followup) { this.$set(this.prices, 'followup_slash', followup.contracts.find(i => i.code === 'YZ_FOLLOW_UP_PLAN_MM').compare_at_prices) }
          this.isFetching = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    fetchCards () {
      this.$axios.get('/billing/cards/')
        .then(resp => {
          this.cards = resp.data.results
        })
        .catch(() => {})
    },
    upgradePlan () {
      this.$router.push(`/admin/billing/subscription/?upgrade=bundle`)
    },
    subscribeBundle () {
      this.isLoading = true
      let data = {
        company: this.company.id,
        contract: 'YZ_PRODUCT_BUNDLE_PLAN_MM',
        card: this.primaryCard ? this.primaryCard.id : null,
        terminate_existing: true
      }
      this.$axios.post(`/subscription/subscriptions/`, data)
        .then(resp => {
          this.$axios.post(`/subscription/bills/${resp.data.bill}/charge_card/`, data)
            .then(() => {
              this.message = 'Subscription successful'
              this.openSuccessDialog = true
            })
            .catch(() => {
              this.message = 'Subscription successful. Please complete the payment to avoid termination.'
              this.openSuccessDialog = true
            })
        })
        .catch(() => {
          this.showMessage(['error', 'Unable to subscribe. Please try different card or contact our support team.'])
          this.isLoading = false
        })
    },
    closeDialog () {
      this.openSuccessDialog = false
      this.showModal = false
      window.location.reload()
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "bundle_offer": "Bundle offer",
    "bundle_offer_desc": "Increase average sales per order through bundle offers to your customers.",
    "section_growth": {
      "title": "Growth Plan",
      "desc": "Get access to all features in Growth. You monthly subscription will be {price}.",
      "features_desc": "Features including but not limited to:",
      "features_1": "Follow Up system (worth {price})",
      "features_agent": "Agent Commission System (worth {price})",
      "features_2": "Integration with WooCommerce & Shopify",
      "features_3": "10 WhatsApp Forms",
      "features_4": "10 Users",
      "button": "Upgrade to growth"
    },
    "section_add_on": {
      "title": "Add-on",
      "desc": "Get access to Bundle features on top of your current plan. Your monthly subscription will be {price}."
    },
    "pay_now": "Pay now",
    "subscribe_as_add_on": "Subscribe as Add-on",
    "monthly": "monthly",
    "upgrade_growth_plan": "Upgrade to Growth Plan",
    "upgrade_growth_plan_confirmation": "Are you sure you want to upgrade to growth plan?",
    "subscribe_bundle_offer": "Subscribe Bundle Offer",
    "subscribe_bundle_offer_confirmation": "Are you sure you want to subscribe Bundle Offer?",
    "subscription_successful": "Subscription successful",
    "subscription_successful_please_complete": "Subscription successful. Please complete the payment to avoid termination.",
    "upgrade_plan_successful": "Upgrade plan successful"
  },
  "id": {
    "bundle_offer": "Penawaran Bundle",
    "bundle_offer_desc": "Tingkatkan penjualan rata-rata per pesanan melalui penawaran Bundle kepada pelanggan kamu.",
    "section_growth": {
      "title": "Growth Plan",
      "desc": "Dapatkan akses ke semua fitur di Pertumbuhan. Langganan bulanan kamu akan menjadi {price}.",
      "features_desc": "Fitur termasuk namun tidak terbatas pada:",
      "features_1": "Sistem Follow Up (senilai {price})",
      "features_agent": "Sistem Komisi Agen (senilai {price})",
      "features_2": "Integrasi dengan WooCommerce & Shopify",
      "features_3": "10 WhatsApp Forms",
      "features_4": "10 Users",
      "button": "Tingkatkan ke growth"
    },
    "section_add_on": {
      "title": "Add-on",
      "desc": "Dapatkan akses ke fitur Bundle selain paket kamu saat ini. Langganan bulanan kamu akan menjadi {price}."
    },
    "pay_now": "Bayar sekarang",
    "subscribe_as_add_on": "Berlangganan sebagai Add-on",
    "monthly": "bulanan",
    "upgrade_growth_plan": "Tingkatkan ke paket Growth",
    "upgrade_growth_plan_confirmation": "Yakin ingin tingkatkan ke paket growth?",
    "subscribe_bundle_offer": "Berlangganan addon Bundle",
    "subscribe_bundle_offer_confirmation": "Yakin ingin berlangganan addon Bundle?",
    "subscription_successful": "Berlangganan berhasil",
    "subscription_successful_please_complete": "Berlangganan berhasil. Harap selesaikan pembayaran untuk menghindari penghentian.",
    "upgrade_plan_successful": "Peningkatan berhasil"
  }
}
</i18n>
